export const fillings = [
  {
    id: 1,
    name: 'Amandină',
    ingredients: ['blat cu cacao', 'cremă de cacao', 'ciocolată', 'sirop'],
    nutritionValues:
      'Valoare energetică 1639 kj / 391 kcal; Grasimi totale 19 g din care acizi grași saturați 6 g; Glucide 49 g, din care zaharuri 37 g; Fibre 1 g; Proteine 4 g; Sare 0.2 g.',
    warnings: 'Poate conține urme de arahide, alune, lapte și derivate.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 2,
    name: 'București',
    ingredients: [
      'blat de cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'vișine',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1565 kj / 372 kcal; Grăsimi totale 10 g, din care acizi grași saturați 6 g; Glucide 52 g, din care zaharuri 34 g; Fibre 2 g; Proteine 4 g; Sare 0.1 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 3,
    name: 'Buturugă',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1835 kj / 437 kcal; Grasimi totale 19 g, din care acizi grași saturați 9 g; Glucide 61 g, din care zaharuri 48 g; Fibre 1 g; Proteine 5 g; Sare 0.06 g.',
    warnings: 'Poate conține urme de alune, arahide, lapte și derivate.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 4,
    name: 'Caraiman',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1835 kj / 437 kcal; Grasimi totale 19 g, din care acizi grași saturați 9 g; Glucide 61 g, din care zaharuri 48 g; Fibre 1 g; Proteine 5 g; Sare 0.06 g.',
    warnings: 'Poate conține urme de alune, arahide, lapte și derivate.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 5,
    name: 'Caramel',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'cremă caramel',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1483 kj / 353 kcal; Grasimi totale 14 g, din care acizi grași saturați 8 g; Glucide 52 g, din care zaharuri 43 g; Fibre 0.4 g; Proteine 4 g; Sare 0.04 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 6,
    name: 'Carpați',
    ingredients: [
      'făină albă din grâu',
      'ouă',
      'zahăr',
      'apă plată',
      'ulei',
      'lapte praf degrasat',
      'unt',
    ],
    nutritionValues:
      'Valoare energetică 1890 kj / 451 kcal; Grasimi totale 24 g, din care acizi grași saturați 12 g; Glucide 56 g, din care zaharuri 36.9 g; Fibre 1.2 g; Proteine 1.90 g; Sare 0.2 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 7,
    name: 'Chec',
    ingredients: [
      'făină albă din grâu',
      'zahăr',
      'apă plată',
      'ulei',
      'lactoză',
    ],
    nutritionValues:
      'Valoare energetică 290 kj / 440 kcal; Grasimi totale 26.1 g, din care acizi grași saturați 9.5 g; Glucide 44.8 g, din care zaharuri 34 g; Fibre 1.2 g; Proteine 6.3 g; Sare 0.08 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 8,
    name: 'Choux à la crème',
    ingredients: ['cremă cu aromă de vanilie', 'coajă de ecler', 'ciocolată'],
    nutritionValues:
      'Valoare energetică 860 kj / 204 kcal; Grasimi totale 5 g, din care acizi grași saturați 1 g; Glucide 36 g, din care zaharuri 18 g; Fibre 0.6 g; Proteine 3 g; Sare 0.07 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 9,
    name: 'Ciocolată Dubai fără zahăr',
    ingredients: ['ciocolată'],
    nutritionValues:
      'Valoare energetică 1787 kj / 427 kcal; Grasimi totale 24 g, din care acizi grași saturați 8.6 g; Îndulcitori 1.4 g; Fibre 2.2 g; Proteine 3.26 g; Sare 0.2 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 10,
    name: 'Ciocolatină',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'vișine',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1565 kj / 372 kcal; Grasimi totale 14 g, din care acizi grași saturați 8 g; Glucide 54 g, din care zaharuri 34 g; Fibre 2 g; Proteine 6 g; Sare 0.1 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 11,
    name: 'Dana',
    ingredients: ['blat alb', 'cremă de cacao', 'sirop', 'arahide'],
    nutritionValues:
      'Valoare energetică 2261 kj / 542 kcal; Grasimi totale 35 g, din care acizi grași saturați 10 g; Glucide 47 g, din care zaharuri 34 g; Fibre 3 g; Proteine 8 g; Sare 0.1 g.',
    warnings: 'Poate conține urme de alune, lapte și derivate.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 12,
    name: "Daniell's",
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'cremă de cocos',
      'sirop',
    ],
    nutritionValues:
      'Valoare energetică 1226 kj / 291 kcal; Grasimi totale 8 g, din care acizi grași saturați 5 g; Glucide 49 g, din care zaharuri 38 g; Fibre 0.5 g; Proteine 4 g; Sare 0.1 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 13,
    name: 'Ecler',
    ingredients: ['cremă cu aromă de vanilie', 'coajă de ecler', 'ciocolată'],
    nutritionValues:
      'Valoare energetică 860 kj / 204 kcal; Grasimi totale 5 g, din care acizi grași saturați 1 g; Glucide 36 g, din care zaharuri 18 g; Fibre 0.6 g; Proteine 3 g; Sare 0.07 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 14,
    name: 'Ferrero',
    ingredients: [
      'făină albă din grâu',
      'ouă',
      'zahăr',
      'ulei',
      'lapte',
      'pudră de cacao',
      'alune de pădure',
    ],
    nutritionValues:
      'Valoare energetică 370 kj / 272 kcal; Grasimi totale 30.2 g, din care acizi grași saturați 25.3 g; Glucide 16 g, din care zaharuri 10.7 g; Fibre 1.2 g; Proteine 6.8 g; Sare 0.06 g.',
    warnings: 'Poate conține alte produse din fructe cu coajă lemnoasă.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 15,
    name: 'Fructa',
    ingredients: ['blat alb', 'cremă vegetală', 'sirop', 'fructe din compot'],
    nutritionValues:
      'Valoare energetică 1240 kj / 296 kcal; Grasimi totale 14 g, din care acizi grași saturați 11 g; Glucide 37 g, din care zaharuri 19 g; Fibre 1 g; Proteine 5 g; Sare 0.07 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 16,
    name: 'Jofre',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
      'nucă',
      'vișine confiate',
    ],
    nutritionValues:
      'Valoare energetică 1835 kj / 437 kcal; Grasimi totale 19 g, din care acizi grași saturați 9 g; Glucide 61 g, din care zaharuri 48 g; Fibre 1 g; Proteine 5 g; Sare 0.06 g.',
    warnings:
      'Poate conține urme de coji de nucă, respectiv sâmburi de vișine.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 17,
    name: 'Mascota',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1344 kj / 320 kcal; Grasimi totale 14 g, din care acizi grași saturați 9 g; Glucide 43 g, din care zaharuri 34 g; Fibre 1 g; Proteine 4 g; Sare 0.07 g.',
    warnings: 'Poate conține alune, arahide.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 18,
    name: 'Mini Imperiale',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
      'nucă',
      'cremă vanilie',
    ],
    nutritionValues:
      'Valoare energetică 1380 kj / 280 kcal; Grasimi totale 28 g, din care acizi grași saturați 16 g; Glucide 45 g, din care zaharuri 36 g; Fibre 2.4 g; Proteine 6 g; Sare 0.1 g.',
    warnings: 'Poate conține coji de nucă.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 19,
    name: 'Mini Nuga',
    ingredients: ['blat', 'cremă', 'nucă', 'rahat'],
    nutritionValues:
      'Valoare energetică 890 kj / 380 kcal; Grasimi totale 14.3 g, din care acizi grași saturați 2.99 g; Glucide 65.7 g, din care zaharuri 35 g; Fibre 0.6 g; Proteine 9.6 g; Sare 0.4 g.',
    warnings: 'Poate conține urme de coji de nucă.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 20,
    name: 'Mini Tosca',
    ingredients: ['blat', 'cremă'],
    nutritionValues:
      'Valoare energetică 1363.9 kj / 326 kcal; Grasimi totale 12.4 g, din care acizi grași saturați 14 g; Glucide 50 g, din care zaharuri 9 g; Fibre 1 g; Proteine 11 g; Sare 0.86 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 21,
    name: 'Mini prăjituri cu cocos și ciocolată',
    ingredients: [
      'blat cu cacao',
      'cremă de cicolată',
      'cremă de cocos',
      'sirop',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1226 kj / 291 kcal; Grasimi totale 8 g, din care acizi grași saturați 5 g; Glucide 49 g, din care zaharuri 38 g; Fibre 0.5 g; Proteine 4 g; Sare 0.1 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 22,
    name: 'Mini prăjitură cu cremă de amandină',
    ingredients: ['blat', 'cremă de cacao', 'ciocolată', 'sirop'],
    nutritionValues:
      'Valoare energetică 1639 kj / 391 kcal; Grasimi totale 19 g, din care acizi grași saturați 6 g; Glucide 49 g, din care zaharuri 37 g; Fibre 1 g; Proteine 4 g; Sare 0.2 g.',
    warnings: 'Poate conține urme de arahide, alune, lapte și derivate.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 23,
    name: 'Mini prăjituri cu cremă de vanilie',
    ingredients: ['blat', 'cremă de vanilie', 'ciocolată albă'],
    nutritionValues:
      'Valoare energetică 820 kj / 202 kcal; Grasimi totale 4 g, din care acizi grași saturați 2 g; Glucide 32 g, din care zaharuri 16 g; Fibre 0.5 g; Proteine 4 g; Sare 0.06 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 24,
    name: 'Mini prăjituri cu mac și cocos',
    ingredients: ['blat', 'cremă', 'fulgi de nucă', 'nucă de cocos'],
    nutritionValues:
      'Valoare energetică 1260 kj / 316 kcal; Grasimi totale 12.4 g, din care acizi grași saturați 10 g; Glucide 11 g, din care zaharuri 9 g; Fibre 1 g; Proteine 11 g; Sare 0.86 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 25,
    name: 'Mini prăjituri cu măr și vanilie',
    ingredients: ['făină albă din grâu', 'ouă', 'zahăr', 'ulei', 'lapte'],
    nutritionValues:
      'Valoare energetică 369 kj / 544 kcal; Grasimi totale 7.6 g, din care acizi grași saturați 2.58 g; Glucide 67 g, din care zaharuri 32 g; Fibre 2 g; Proteine 6.42 g; Sare 0.1 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 26,
    name: 'Mini prăjituri cu nes și nucă',
    ingredients: ['blat', 'cremă'],
    nutritionValues:
      'Valoare energetică 1387 kj / 331 kcal; Grasimi totale 21 g, din care acizi grași saturați 14.7 g; Glucide 30.45 g, din care zaharuri 18.7 g; Fibre 2 g; Proteine 5.23 g; Sare 0.20 g.',
    warnings: 'Poate conține urme de coji de nucă.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 27,
    name: 'Mouss ciocolată albă',
    ingredients: [
      'făină albă din grâu',
      'ouă',
      'zahăr',
      'ulei',
      'lapte praf degresat',
      'fulgi de nucă de cocos',
    ],
    nutritionValues:
      'Valoare energetică 1823 kj / 627 kcal; Grasimi totale 48.3 g, din care acizi grași saturați 29.5 g; Glucide 18.8 g, din care zaharuri 33.6 g; Fibre 1.2 g; Proteine 7.4 g; Sare 0.08 g.',
    warnings: 'Poate conține alte produse din fructe cu coajă lemnoasă.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 28,
    name: 'Pădurea neagră',
    ingredients: [
      'cremă vegetală',
      'blat cu cacao',
      'cremă albă',
      'sirop de glucoză',
      'zmeură',
      'afine',
      'mure',
      'căpșuni',
    ],
    nutritionValues:
      'Valoare energetică 1860 kj / 445 kcal; Grasimi totale 34 g, din care acizi grași saturați 19.8 g; Glucide 31 g, din care zaharuri 28 g; Fibre 39 g; Proteine 5 g; Sare 0.402 g.',
    warnings: 'Pot conține urme de fructe.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 29,
    name: 'Pompadour',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
      'cremă vanilie',
    ],
    nutritionValues:
      'Valoare energetică 1444 kj / 343 kcal; Grasimi totale 12 g, din care acizi grași saturați 8 g; Glucide 52 g, din care zaharuri 32 g; Fibre 1.5 g; Proteine 6 g; Sare 0.1 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 30,
    name: 'Popcorn',
    ingredients: [
      'boabe de porumb pentru popcorn',
      'grăsime semi-lichidă pentru popcorn',
    ],
    nutritionValues:
      'Valoare energetică 1650 kj / 391 kcal; Grasimi totale 4.7 g, din care acizi grași saturați 0.7 g; Glucide 74 g, din care zaharuri 0.6 g; Fibre 7.3 g; Proteine 9.4 g; Sare 0.09 g.',
    warnings: 'Poate conține urme de lapte.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 31,
    name: 'Prăjituri de casă cu miniecler',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
      'cremă vanilie',
    ],
    nutritionValues:
      'Valoare energetică 1382 kj / 329 kcal; Grasimi totale 13 g, din care acizi grași saturați 6 g; Glucide 46 g, din care zaharuri 33 g; Fibre 0.6 g; Proteine 5 g; Sare 0.09 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 32,
    name: 'Prăjituri de casă',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
      'cremă vanilie',
    ],
    nutritionValues:
      'Valoare energetică 1382 kj / 329 kcal; Grasimi totale 13 g, din care acizi grași saturați 6 g; Glucide 46 g, din care zaharuri 33 g; Fibre 0.6 g; Proteine 5 g; Sare 0.09 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 33,
    name: 'Raffaello',
    ingredients: [
      'făină albă din grâu',
      'ouă',
      'zahăr',
      'ulei',
      'lapte praf degresat',
      'arahide granulate',
      'fulgi de nucă de cocos',
    ],
    nutritionValues:
      'Valoare energetică 1823 kj / 627 kcal; Grasimi totale 48.3 g, din care acizi grași saturați 29.5 g; Glucide 18.8 g, din care zaharuri 33.6 g; Fibre 1.2 g; Proteine 7.4 g; Sare 0.08 g.',
    warnings: 'Poate conține alte produse din fructe cu coajă lemnoasă.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 34,
    name: 'Rozette',
    ingredients: ['blat alb', 'cremă vegetală', 'cremă vișine', 'sirop'],
    nutritionValues:
      'Valoare energetică 1041 kj / 248 kcal; Grasimi totale 10 g, din care acizi grași saturați 9 g; Glucide 34 g, din care zaharuri 23 g; Fibre 0.3 g; Proteine 4 g; Sare 0.05 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 35,
    name: 'Savarină',
    ingredients: [
      'cremă vegetală',
      'coajă de savarină',
      'gel de decor',
      'sirop',
    ],
    nutritionValues:
      'Valoare energetică 1351 kj / 321 kcal; Grasimi totale 11 g, din care acizi grași saturați 7 g; Glucide 52 g, din care zaharuri 35 g; Fibre 0.6 g; Proteine 4 g; Sare 0.06 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 36,
    name: 'Sonda',
    ingredients: [
      'cremă vegetală',
      'blat cu cacao',
      'cremă Toffi',
      'cremă albă',
      'sirop de gucoză',
    ],
    nutritionValues:
      'Valoare energetică 1390 kj / 331 kcal; Grasimi totale 15 g, din care acizi grași saturați 9 g; Glucide 43 g, din care zaharuri 32 g; Fibre 1.5 g; Proteine 5 g; Sare 0.1 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 37,
    name: 'Tiramisu',
    ingredients: ['cremă vegetală', 'blat cu cacao', 'cremă Tiramisu', 'sirop'],
    nutritionValues:
      'Valoare energetică 910 kj / 217 kcal; Grasimi totale 10 g, din care acizi grași saturați 9 g; Glucide 28 g, din care zaharuri 18 g; Fibre 0.2 g; Proteine 3 g; Sare 0.06 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
  {
    id: 38,
    name: 'Tort Caramel',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'cremă caramel',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1483 kj / 353 kcal; Grasimi totale 14 g, din care acizi grași saturați 8 g; Glucide 52 g, din care zaharuri 43 g; Fibre 0.4 g; Proteine 4 g; Sare 0.04 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 39,
    name: 'Tort Cremă și vișine',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'cremă caramel',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1730 kj / 418 kcal; Grasimi totale 19 g, din care acizi grași saturați 9 g; Glucide 58 g, din care zaharuri 42 g; Fibre 1 g; Proteine 4 g; Sare 0.05 g.',
    warnings: 'Poate conține urme de sâmburi de vișine.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 40,
    name: "Tort Daniell's",
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'cremă de cocos',
      'sirop',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1226 kj / 291 kcal; Grasimi totale 8 g, din care acizi grași saturați 5 g; Glucide 49 g, din care zaharuri 38 g; Fibre 0.5 g; Proteine 4 g; Sare 0.1 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 41,
    name: 'Tort de Ciocolată',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
    ],
    nutritionValues:
      'Valoare energetică 1835 kj / 437 kcal; Grasimi totale 19 g, din care acizi grași saturați 9 g; Glucide 61 g, din care zaharuri 48 g; Fibre 1 g; Proteine 5 g; Sare 0.06 g.',
    warnings: 'Poate conține urme de alune, arahide, lapte și derivate.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 42,
    name: 'Tort Exotic',
    ingredients: ['blat alb', 'cremă vegetală', 'sirop', 'fructe din compot'],
    nutritionValues:
      'Valoare energetică 1240 kj / 296 kcal; Grasimi totale 14 g, din care acizi grași saturați 11 g; Glucide 37 g, din care zaharuri 19 g; Fibre 1 g; Proteine 5 g; Sare 0.07 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 43,
    name: 'Tort Ferrero',
    ingredients: [
      'făină albă din grâu',
      'ouă',
      'zahăr',
      'ulei',
      'lapte praf degresat',
      'pudră de cacao',
      'alune de pădure',
    ],
    nutritionValues:
      'Valoare energetică 370 kj / 272 kcal; Grasimi totale 30.2 g, din care acizi grași saturați 25.3 g; Glucide 16 g, din care zaharuri 10.7 g; Fibre 1.2 g; Proteine 6.8 g; Sare 0.06 g.',
    warnings: 'Poate conține alte produse din fructe cu coajă lemnoasă.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 44,
    name: 'Tort Jofre 1',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
      'nucă',
      'vișine confiate',
    ],
    nutritionValues:
      'Valoare energetică 1835 kj / 437 kcal; Grasimi totale 19 g, din care acizi grași saturați 9 g; Glucide 61 g, din care zaharuri 48 g; Fibre 1 g; Proteine 5 g; Sare 0.06 g.',
    warnings:
      'Poate conține urme de coji de nucă, respectiv sâmburi de vișine.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 45,
    name: 'Tort Jofre',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
      'nucă',
      'vișine confiate',
    ],
    nutritionValues:
      'Valoare energetică 1835 kj / 437 kcal; Grasimi totale 19 g, din care acizi grași saturați 9 g; Glucide 61 g, din care zaharuri 48 g; Fibre 1 g; Proteine 5 g; Sare 0.06 g.',
    warnings:
      'Poate conține urme de coji de nucă, respectiv sâmburi de vișine.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 46,
    name: 'Tort Pădurea neagră',
    ingredients: [
      'cremă vegetală',
      'blat cu cacao',
      'cremă albă',
      'sirop de glucoză',
      'zmeură',
      'afine',
      'mure',
      'căpșuni',
    ],
    nutritionValues:
      'Valoare energetică 1860 kj / 445 kcal; Grasimi totale 34 g, din care acizi grași saturați 19.8 g; Glucide 31 g, din care zaharuri 28 g; Fibre 39 g; Proteine 5 g; Sare 0.402 g.',
    warnings: 'Poate conține urme fructe.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 47,
    name: 'Tort Pompadour',
    ingredients: [
      'blat cu cacao',
      'cremă de ciocolată',
      'ciocolată',
      'sirop',
      'gel de decor',
      'cremă vanilie',
    ],
    nutritionValues:
      'Valoare energetică 1444 kj / 343 kcal; Grasimi totale 12 g, din care acizi grași saturați 8 g; Glucide 52 g, din care zaharuri 32 g; Fibre 1.5 g; Proteine 6 g; Sare 0.1 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 48,
    name: 'Tort Raffaello',
    ingredients: [
      'făină albă din grâu',
      'ouă',
      'zahăr',
      'ulei',
      'lapte praf degresat',
      'arahide granulate',
      'fulgi de nucă de cocos',
    ],
    nutritionValues:
      'Valoare energetică 1823 kj / 627 kcal; Grasimi totale 48.3 g, din care acizi grași saturați 29.5 g; Glucide 18.8 g, din care zaharuri 33.6 g; Fibre 1.2 g; Proteine 7.4 g; Sare 0.08 g.',
    warnings: 'Poate conține alte produse din fructe cu coajă lemnoasă.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 49,
    name: 'Tort Trio Mousse',
    ingredients: [
      'făină albă din grâu',
      'ouă',
      'zahăr',
      'ulei',
      'lapte praf degresat',
      'pudră de cacao',
      'alune de pădure',
    ],
    nutritionValues:
      'Valoare energetică 370 kj / 272 kcal; Grasimi totale 30.2 g, din care acizi grași saturați 25.3 g; Glucide 16 g, din care zaharuri 10.7 g; Fibre 1.2 g; Proteine 6.8 g; Sare 0.06 g.',
    warnings: 'Poate conține alte produse din fructe cu coajă lemnoasă.',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'cakes',
  },
  {
    id: 50,
    name: 'Yogurtina',
    ingredients: ['blat alb', 'cremă cu aromă de iaurt', 'gel vișine', 'sirop'],
    nutritionValues:
      'Valoare energetică 1160 kj / 277 kcal; Grasimi totale 15 g, din care acizi grași saturați 10 g; Glucide 30 g, din care zaharuri 20 g; Fibre 0.3 g; Proteine 4 g; Sare 0.07 g.',
    warnings: '',
    storageConditions: 'A se păstra în loc uscat și răcoros, între 0-4°C.',
    type: 'desserts',
  },
];

export const removeDiacritics = str => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
